import { State } from 'state'
import { TFunction } from 'i18next'

export const ErrorCodes = {
    EXPIRED_LINK: 'EXPIRED_LINK',
    DUPLICATE_PASSWORD: 'DUPLICATE_PASSWORD',
    PASSWORD_TOO_COMMON: 'PASSWORD_TOO_COMMON',
    PASSWORD_TOO_SIMILAR: 'PASSWORD_TOO_SIMILAR',
    INVALID_EMAIL: 'INVALID_EMAIL',
    EMAIL_ALREADY_IN_USED_FOR_APP: 'EMAIL_ALREADY_IN_USED_FOR_APP',
    PASSWORD_DOES_NOT_MATCH: 'PASSWORD_DOES_NOT_MATCH',
    PASSWORD_TOO_SHORT: 'PASSWORD_TOO_SHORT',
    USER_IS_INTERNAL: 'USER_IS_INTERNAL',
}

export const errorMessages = (t: TFunction, isSignUp?: boolean) => {
    return {
        [ErrorCodes.INVALID_EMAIL]: t('errorMessage.resetPassword.cantFindEmail'),
        [ErrorCodes.DUPLICATE_PASSWORD]: t('errorMessage.forgetPassword.repeatedOldPassword'),
        [ErrorCodes.PASSWORD_TOO_COMMON]: t('errorMessage.signUp.commonPassword'),
        [ErrorCodes.PASSWORD_TOO_SIMILAR]: t('errorMessage.signUp.passwordSimilarToEmail'),
        [ErrorCodes.EMAIL_ALREADY_IN_USED_FOR_APP]: isSignUp
            ? t('logIn.resetPassword.emailErrorMessage.hasRegisterApp')
            : t('errorMessage.validation.emailAddressAlreadyInAppSubtext'),
        [ErrorCodes.PASSWORD_DOES_NOT_MATCH]: t('errorMessage.password.samePassword'),
        [ErrorCodes.PASSWORD_TOO_SHORT]: t('errorMessage.password.characterLengthAndCombination'),
        [ErrorCodes.USER_IS_INTERNAL]: t('logIn.resetPassword.emailErrorMessage.hasRegisterInternal'),
    }
}

export const selectAuthErrors = (state: State): Record<string, string> | null => {
    return state.errors.auth
}
